import { render, staticRenderFns } from "./GenDataBaseTypeList.vue?vue&type=template&id=d549cfdc&scoped=true"
var script = {}
import style0 from "./GenDataBaseTypeList.vue?vue&type=style&index=0&id=d549cfdc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d549cfdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d549cfdc')) {
      api.createRecord('d549cfdc', component.options)
    } else {
      api.reload('d549cfdc', component.options)
    }
    module.hot.accept("./GenDataBaseTypeList.vue?vue&type=template&id=d549cfdc&scoped=true", function () {
      api.rerender('d549cfdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/gen/GenDataBaseTypeList.vue"
export default component.exports